module.exports = __webpack_public_path__ + "img/th.9f030e97.png";